import { SharedState } from '@trello/shared-state';
// eslint-disable-next-line no-restricted-imports
import {
  BoardsMenuSelectedItemModel,
  ReopenBoardPopoverModel,
} from 'app/gamma/src/types/models';
import { getRecentBoards } from 'app/src/components/RecentlyViewedBoardsMenu/recentBoardsState';

export interface BoardsMenuState {
  idRecentBoards: string[];
  isDeletingBoard: {
    [key: string]: boolean;
  };
  loading: boolean;
  pastQueries: {
    query: string;
    limited: boolean;
  }[];
  reopenBoardPopover: ReopenBoardPopoverModel | null;
  searchText: string;
  selectedBoard: BoardsMenuSelectedItemModel | null;
}

// eslint-disable-next-line @trello/no-module-logic
const idRecentBoards = getRecentBoards().map((board) => board.id);
const initialState: BoardsMenuState = {
  idRecentBoards,
  isDeletingBoard: {},
  loading: false,
  pastQueries: [],
  reopenBoardPopover: null,
  searchText: '',
  selectedBoard: null,
};

// This is defined/exported in this file instead of boards-menu.ts to avoid circular dependencies.
export const boardsMenuState = new SharedState<BoardsMenuState>(initialState);
